module.exports = __webpack_public_path__ + "img/home-fhc2.dfd167ba.png";